import { useParams } from "react-router-dom";
import MainMenu from "../component/menu_frame";
import { getInventoryItems } from "../methods/app_halper";
import { Avatar, Box, Button, Card, CardBody, CardFooter, CardHeader, Divider, Flex, GridItem, Heading, IconButton, Image, Link, Menu, MenuButton, MenuItem, MenuList, Modal, ModalContent, ModalOverlay, SimpleGrid, SkeletonCircle, SkeletonText, Tag, Text } from "@chakra-ui/react";
import { useState } from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import QRCode from "react-qr-code";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import MoreVertIcon from '@mui/icons-material/MoreVert';

function Department() {
    const { department, category } = useParams();
    const [data, setData] = useState(null);
    const [project, setProject] = useState(null);

    if (data === null) {
        getInventoryItems(department, category).then((res) => {
            setData(res);
        }).catch((err) => {
            console.error(err);
            setData([])
        });
    }

    return (
        <MainMenu>
            <Modal isOpen={project !== null} onClose={() => { setProject(null); }}>
                <ModalOverlay />
                <ModalContent>
                    {project === null ? "" :
                        <Card height={'100%'}>
                            {project.image_link === null ? "" : <Image objectFit='cover' src={project.image_link} alt={project.appname} borderRadius='lg' maxH={128} />}
                            <CardHeader>
                                <Flex spacing='4'>
                                    <Flex flex='1' gap='4' alignItems='center' flexWrap='wrap'>
                                        <Avatar name={project.appname} />
                                        <Box>
                                            <Heading size='sm' mb={0.5}>{project.appname}</Heading>
                                            <Text fontSize="sm">
                                                {project.category}
                                                {project.sub_category && (
                                                    <Tag ml={1} size="sm" variant="subtle" colorScheme="gray">
                                                        <small>{project.sub_category}</small>
                                                    </Tag>
                                                )}
                                            </Text>
                                        </Box>
                                    </Flex>
                                    <Menu>
                                        <MenuButton variant='ghost' colorScheme='gray' as={IconButton}>
                                            <IconButton variant='ghost' colorScheme='gray' icon={<MoreVertIcon />} />
                                        </MenuButton>
                                        <MenuList>
                                            <MenuItem>Edit</MenuItem>
                                            <MenuItem>Permission</MenuItem>
                                            <Divider />
                                            <MenuItem>Delete</MenuItem>
                                        </MenuList>
                                    </Menu>
                                </Flex>
                            </CardHeader>
                            <CardBody>
                                <Text fontSize='sm'>#{project.appid}</Text>
                                <Text fontSize='sm'>Department: {project.department} <Tag colorScheme={"orange"}><small>{project.platform}</small></Tag></Text>
                                <Text fontSize='sm'>Source: <Link isExternal href={project.source_link}>{project.source}</Link></Text>
                                <Text fontSize='sm'>Created: {project.created_on}</Text>
                                <Text fontSize='sm'>Last Update: {project.updated_on}</Text>
                                <Divider />
                                <Text textAlign="justify">{project.description}</Text>
                            </CardBody>
                            <Divider />
                            <CardFooter justify='space-between' flexWrap='wrap' >
                                <Button flex='1' variant='ghost'><Link isExternal href={project.appurl}>Open <ExternalLinkIcon mx='2px' /></Link></Button>
                                {project.appurl === null ? "" :
                                    <Menu>
                                        <MenuButton flex='1' variant='ghost' as={Button} leftIcon={<QrCodeScannerIcon />}>
                                            Show QR
                                        </MenuButton>
                                        <MenuList style={{ width: "100%", textAlign: "center" }}>
                                            <MenuItem><QRCode size={200} style={{ height: "auto", maxWidth: "100%" }} value={project.appurl} /></MenuItem>
                                        </MenuList>
                                    </Menu>
                                }
                            </CardFooter>
                        </Card>
                    }
                </ModalContent>
            </Modal>

            {data === null ?
                <Box padding='6' boxShadow='sm' bg='white'>
                    <SkeletonCircle size='10' />
                    <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
                </Box>
                :
                <SimpleGrid columns={[1, 2, 3, 4]} spacing='10px' gap={4} padding={5}>
                    {
                        data.map((item, idx) => (
                            <GridItem key={idx}>
                                <Card height={'100%'} p={3}>
                                    <CardHeader py={2} px={3}>
                                        <Flex justify="space-between" align="center">
                                            <Flex flex="1" gap={2} align="center" wrap="wrap">
                                                <Avatar name={item.appname} size="md" />
                                                <Box>
                                                    <Heading size="sm" mb={0.5}>{item.appname}</Heading>
                                                    <Text fontSize="sm">
                                                        {item.category}
                                                        {item.sub_category && (
                                                            <Tag ml={1} size="sm" variant="subtle" colorScheme="gray">
                                                                <small>{item.sub_category}</small>
                                                            </Tag>
                                                        )}
                                                    </Text>                                                </Box>
                                            </Flex>
                                            <Link isExternal href={item.appurl}><ExternalLinkIcon /></Link>
                                        </Flex>
                                    </CardHeader>
                                    <CardBody py={2} px={3}>
                                        <Text textAlign="justify" noOfLines={3}>{item.description.substring(0, 80) + "..."}</Text>
                                    </CardBody>
                                    <CardFooter py={2} px={3} justifyContent="flex-end">
                                        <Button variant="outline" py={2} px={3} colorScheme="gray" onClick={() => { setProject(item) }} >Details</Button>
                                    </CardFooter>
                                </Card>
                            </GridItem>
                        ))
                    }
                </SimpleGrid>
            }
        </MainMenu>
    );
}

export default Department
